import { Route, Routes, Navigate } from 'react-router-dom';
import {
 Login,
 Companies,
 Companie,
 Researches,
 QuestionnaireSimpleEdit,
 DiagnosisEdit,
 PeriodicEdit,
 QuestionnaireRegister,
 Template,
 SurveysTemplate,
 SurveyTemplateForm,
 Respondents,
 Reviewers,
 Questionnaires,
 Analysis,
 SurveyAnalysis,
 Certifications,
 CreateCertification,
 CertificationEdit,
 EditCertification,
 ResetPassword,
 EsgStarter,
 Pillars,
 Themes,
 AccessRequests,
 Schedules,
 ScheduleDetail,
 DashboardsHome,
 DashboardsPortfolio,
 DashboardsWorkflow,
 DashboardsHistory,
 DashboardsByCompany,
 DashboardsDataQuality,
 Audit,
 AuditView,
 GriIndicators,
 ComparisonGroups,
 GriDashboard,
 Documents,
 DocumentFolders,
 EducationalContent,
} from './../pages';
import PublicRoute from './PublicRoute';
import Topbar from '../components/Layout/Topbar';
import PrivateRoute from './PrivateRoute';
import { useSSO } from '../context/SSO';

function RoutesApp() {
 const auth = useSSO();
 const roles = auth?.user?.user?.roles || [];
 const hasMasterRole = roles.some(role => role.name === 'MASTER');
 const hasAdminCompanyRole = roles.some(role => role.name === 'RESPONSAVEL');
 const hasEvaluatorRole = roles.some(role => role.name === 'AVALIADOR');

 const showMasterRoutes = hasMasterRole;
 const showAdminCompanyRoutes = !hasMasterRole && hasAdminCompanyRole;
 // AVALIADOR (não-MASTER) acessa Auditoria (EG-46) e Cronogramas (dos que é vinculado).
 const showEvaluatorRoutes = !hasMasterRole && hasEvaluatorRole;

 return (
  <Routes>
   <Route
    index
    element={
     <PublicRoute>
      <Login />
     </PublicRoute>
    }
   />
   <Route
    path='/login'
    element={
     <PublicRoute>
      <Login />
     </PublicRoute>
    }
   />
   <Route
    path='/reset-password'
    element={
     <PrivateRoute>
      <ResetPassword />
     </PrivateRoute>
    }
   />
   
   {showAdminCompanyRoutes && (
    <Route element={<Topbar />}>
     <Route
      path='/survey-analysis'
      element={
       <PrivateRoute>
        <Analysis />
       </PrivateRoute>
      }
     />
     <Route
      path='/survey-analysis/:id'
      element={
       <PrivateRoute>
        <SurveyAnalysis />
       </PrivateRoute>
      }
     />
     <Route
      path='/gri-dashboard'
      element={
       <PrivateRoute>
        <GriDashboard />
       </PrivateRoute>
      }
     />
    </Route>
   )}

   {showEvaluatorRoutes && (
    <Route element={<Topbar />}>
     <Route
      path='/audit'
      element={
       <PrivateRoute>
        <Audit />
       </PrivateRoute>
      }
     />
     <Route
      path='/audit/view'
      element={
       <PrivateRoute>
        <AuditView />
       </PrivateRoute>
      }
     />
     <Route
      path='/cronogramas'
      element={
       <PrivateRoute>
        <Schedules />
       </PrivateRoute>
      }
     />
     <Route
      path='/cronogramas/:id'
      element={
       <PrivateRoute>
        <ScheduleDetail />
       </PrivateRoute>
      }
     />
    </Route>
   )}

   {showMasterRoutes && (
    <>
     <Route element={<Topbar />}>
      <Route
       path='/audit'
       element={
        <PrivateRoute>
         <Audit />
        </PrivateRoute>
       }
      />
      <Route
       path='/audit/view'
       element={
        <PrivateRoute>
         <AuditView />
        </PrivateRoute>
       }
      />

      <Route
       path='/cronogramas'
       element={
        <PrivateRoute>
         <Schedules />
        </PrivateRoute>
       }
      />

      <Route
       path='/cronogramas/:id'
       element={
        <PrivateRoute>
         <ScheduleDetail />
        </PrivateRoute>
       }
      />

      <Route
       path='/documents'
       element={
        <PrivateRoute>
         <Documents />
        </PrivateRoute>
       }
      />

      <Route
       path='/documents/:idCompanyGroup'
       element={
        <PrivateRoute>
         <DocumentFolders />
        </PrivateRoute>
       }
      />

      {/* Estático vence dinâmico no matching do react-router v6, então isso não
          colide com /documents/:idCompanyGroup mesmo declarado depois. */}
      <Route
       path='/documents/global'
       element={
        <PrivateRoute>
         <DocumentFolders isGlobal />
        </PrivateRoute>
       }
      />

      <Route
       path='/educational-content'
       element={
        <PrivateRoute>
         <EducationalContent />
        </PrivateRoute>
       }
      />

      <Route
       path='/registration'
       element={
        <PrivateRoute>
         <Companies />
        </PrivateRoute>
       }
      />

      <Route
       path='/registration/questionnaires/:id'
       element={
        <PrivateRoute>
         <Questionnaires />
        </PrivateRoute>
       }
      />

      <Route
       path='/researches'
       element={
        <PrivateRoute>
         <Researches />
        </PrivateRoute>
       }
      />

      <Route
       path='/templates'
       element={
        <PrivateRoute>
         <SurveysTemplate />
        </PrivateRoute>
       }
      />

      <Route
       path='/gri-indicators'
       element={
        <PrivateRoute>
         <GriIndicators />
        </PrivateRoute>
       }
      />

      <Route
       path='/comparison-groups'
       element={
        <PrivateRoute>
         <ComparisonGroups />
        </PrivateRoute>
       }
      />

      <Route
       path='/gri-dashboard'
       element={
        <PrivateRoute>
         <GriDashboard />
        </PrivateRoute>
       }
      />

      <Route
       path='/esg-starter'
       element={
        <PrivateRoute>
         <EsgStarter />
        </PrivateRoute>
       }
      />

      <Route
       path='/pillars'
       element={
        <PrivateRoute>
         <Pillars />
        </PrivateRoute>
       }
      />

      <Route
       path='/themes'
       element={
        <PrivateRoute>
         <Themes />
        </PrivateRoute>
       }
      />

      <Route
       path='/certifications'
       element={
        <PrivateRoute>
         <Certifications />
        </PrivateRoute>
       }
      />

      <Route
       path='/dashboards'
       element={
        <PrivateRoute>
         <DashboardsHome />
        </PrivateRoute>
       }
      />
      <Route
       path='/dashboards/portfolio'
       element={
        <PrivateRoute>
         <DashboardsPortfolio />
        </PrivateRoute>
       }
      />
      <Route
       path='/dashboards/fluxo'
       element={
        <PrivateRoute>
         <DashboardsWorkflow />
        </PrivateRoute>
       }
      />
      <Route
       path='/dashboards/historico'
       element={
        <PrivateRoute>
         <DashboardsHistory />
        </PrivateRoute>
       }
      />
      <Route
       path='/dashboards/por-empresa'
       element={
        <PrivateRoute>
         <DashboardsByCompany />
        </PrivateRoute>
       }
      />
      <Route
       path='/dashboards/qualidade'
       element={
        <PrivateRoute>
         <DashboardsDataQuality />
        </PrivateRoute>
       }
      />

      <Route
       path='/access-requests'
       element={
        <PrivateRoute>
         <AccessRequests />
        </PrivateRoute>
       }
      />
     </Route>

     <Route
      path='/certifications/create'
      element={
       <PrivateRoute>
        <CreateCertification />
       </PrivateRoute>
      }
     />

     <Route
      path='/certifications/edit/:id'
      element={
       <PrivateRoute>
        <EditCertification />
       </PrivateRoute>
      }
     />

     <Route
      path='/registration/company/respondents/:id'
      element={
       <PrivateRoute>
        <Respondents />
       </PrivateRoute>
      }
     />

     <Route
      path='/registration/company/reviewers/:id'
      element={
       <PrivateRoute>
        <Reviewers />
       </PrivateRoute>
      }
     />

     <Route
      path='/registration/company'
      element={
       <PrivateRoute>
        <Companie />
       </PrivateRoute>
      }
     />

     <Route
      path='/researches/edit/:id'
      element={
       <PrivateRoute>
        <QuestionnaireSimpleEdit />
       </PrivateRoute>
      }
     />

     <Route
      path='/researches/diagnosis/:id'
      element={
       <PrivateRoute>
        <DiagnosisEdit />
       </PrivateRoute>
      }
     />

     <Route
      path='/researches/periodic/:id'
      element={
       <PrivateRoute>
        <PeriodicEdit />
       </PrivateRoute>
      }
     />

     <Route
      path='/researches/certification/:id'
      element={
       <PrivateRoute>
        <CertificationEdit />
       </PrivateRoute>
      }
     />

     <Route
      path='/researches/register/:id'
      element={
       <PrivateRoute>
        <QuestionnaireRegister />
       </PrivateRoute>
      }
     />

     <Route
      path='/templates/create'
      element={
       <PrivateRoute>
        <Template />
       </PrivateRoute>
      }
     />

     <Route
      path='/templates/:id'
      element={
       <PrivateRoute>
        <SurveyTemplateForm />
       </PrivateRoute>
      }
     />
    </>
   )}
   
   {/* Rota catch-all para rotas não encontradas */}
   <Route
    path='*'
    element={
     // Enquanto o SSO valida o token as rotas por papel ainda não existem;
     // redirecionar aqui tirava o usuário da URL que ele pediu (abrir a
     // auditoria direto caía em /registration).
     auth?.isAuthLoading ? null : auth?.authenticated ? (
      (() => {
       const roles = auth?.user?.user?.roles || [];
       const hasMasterRole = roles.some(role => role.name === 'MASTER');
       const hasAdminCompanyRole = roles.some(role => role.name === 'RESPONSAVEL');
       const hasEvaluatorRole = roles.some(role => role.name === 'AVALIADOR');

       if (hasMasterRole) {
        return <Navigate to="/registration" replace />;
       } else if (hasAdminCompanyRole) {
        return <Navigate to="/survey-analysis" replace />;
       } else if (hasEvaluatorRole) {
        return <Navigate to="/audit" replace />;
       } else {
        return <Navigate to="/login" replace />;
       }
      })()
     ) : (
      <Navigate to="/login" replace />
     )
    }
   />
  </Routes>
 );
}

export default RoutesApp;